import axios from "axios";

export function useCrud() {
    async function getAsync(url: string, params: any = {headers: {'X-Requested-With': 'XMLHttpRequest'}}): Promise<any> {
        try {
            const response = await axios.get(url, params);
            return response.data;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async function postAsync(url: string, data: any = {}, type: string = 'application/json'): Promise<any> {
        try {
            const response = await axios.post(url, data, {headers: {'Content-Type': type}});
            return response.data;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    async function postFormAsync(url: string, data: any = {}): Promise<any> {
        try {
            const response = await axios.postForm(url, data);
            return response.data;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    return {getAsync, postAsync, postFormAsync}
}